import api from "../api";
import {iniciarRequisicao, logout} from "../../helpers";
import {STATUS_HTTP} from "../statusHTTP";

export const buscarProdutosCompraPorCategoria = async (params) => {
  const url = `/produtos/categorias/${params.idcategoria}`;
  const {data: dados, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = dados.token;
    return dados.produtos.map(item => {
      return {
        ...item,
        iddepartamento: params.iddepartamento,
        idsecao: params.idsecao,
        idcategoria: params.idcategoria
      };
    });
  }

  logout();
}
